/** ***********
*
* <certificates.module.ts v1.0>
*
* Copyright (c) 2022 AIRBUS OPERATIONS
*
* Contributors:
*  PEREIRA Thomas [SOPRA STERIA] [thomas.pereira@soprasteria.com]
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
 * All rights reserved.
**************/

import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppMaterialModule } from 'src/app/material.modules'
import { SharedTranslationModule } from '../shared/shared-translation.module'
import { FilterModule } from '../filter/filter.module'
import { ManageCertificatesComponent } from './manage-certificates/manage-certificates.component'
import { DialogCreateCertificateRequestComponent } from './dialog/dialog-create-certificate/dialog-create-certificate-request.component'
import { SharedModule } from '../shared/shared.module'
import { DialogCertificateTotpComponent } from './dialog/dialog-certificate-totp/dialog-certificate-totp.component'
import { RouterModule } from '@angular/router'
import { scopeGuard } from 'src/app/auth/scope.guard';
import { TranslateModule } from '@ngx-translate/core';
import { StatusProgressComponent } from './status-progress/status-progress.component';
import { StatusStepComponent } from './status-progress/status-step/status-step.component';
import { StatusSeparatorComponent } from './status-progress/status-separator/status-separator.component';
import { DialogCertificateStatusProgressDetailedComponent } from './status-progress/dialog-detailed/dialog-detailed.component';

@NgModule({
    declarations: [
        ManageCertificatesComponent,
        DialogCreateCertificateRequestComponent,
        DialogCertificateTotpComponent,
        StatusProgressComponent,
        StatusStepComponent,
        StatusSeparatorComponent,
        DialogCertificateStatusProgressDetailedComponent
    ],
    imports: [
        CommonModule,
        AppMaterialModule,
        SharedTranslationModule,
        FormsModule,
        ReactiveFormsModule,
        FilterModule,
        SharedModule,
        TranslateModule.forChild({ extend: true }),
        RouterModule.forChild([
            {
                path: '',
                component: ManageCertificatesComponent,
                canActivate: [scopeGuard],
                data: { role: 'oversize' }
            },
        ]),
    ],
    providers: [],
})
export class CertificatesModule { }
